export const API_BASE_URL_ENV = () => {
	return "https://back.fm90valet.com/api";
};
